module.exports = __webpack_public_path__ + "static/3-2d7e35501fdadbaa162a7d72cdc1f6f6.jpg";